// Phase 3 Task 23 — drives the "Opens in HH:MM:SS" countdown shown
// on the non-live landing page when the event is today but scanning
// hasn't started yet (scan_start_date > today). Reads its target
// timestamp from `data-countdown-target-at-value` and updates a
// `data-countdown-target="display"` element each second.
//
// When the target is in the past, displays "00:00:00" and stops.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values  = { targetAt: String }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.hasDisplayTarget) return
    if (!this.targetAtValue) {
      this.displayTarget.textContent = "--:--:--"
      return
    }

    const target = new Date(this.targetAtValue).getTime()
    const now    = Date.now()
    const diff   = Math.max(0, target - now)

    const hours   = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    const pad = (n) => String(n).padStart(2, "0")
    this.displayTarget.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`

    if (diff === 0 && this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
